let playing: HTMLMediaElement | null = null;

export function claimPlayback(media: HTMLMediaElement): void {
  const previous = playing;
  playing = media;
  if (previous && previous !== media) previous.pause();
}

export function releasePlayback(media: HTMLMediaElement): void {
  if (playing === media) playing = null;
}

export function stopPlayback(media: HTMLMediaElement): void {
  releasePlayback(media);
  media.pause();
}

export function currentPlayback(): HTMLMediaElement | null {
  return playing;
}

export function formatPlaybackTime(seconds: number): string {
  const total = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = String(total % 60).padStart(2, '0');
  if (hours > 0) return `${String(hours)}:${String(minutes).padStart(2, '0')}:${secs}`;
  return `${String(minutes)}:${secs}`;
}
